import { Controller } from "@hotwired/stimulus"

// Filters return inventory in place. The address bar updates; the page does not reload.
export default class extends Controller {
  static targets = ["query", "summary", "results", "clear"]
  static values = { url: String }

  connect() {
    this.onPopState = () => {
      const term = new URLSearchParams(window.location.search).get("search") || ""
      this.queryTarget.value = term
      this.visit(term, { push: false })
    }
    window.addEventListener("popstate", this.onPopState)
  }

  disconnect() {
    window.removeEventListener("popstate", this.onPopState)
  }

  submit(event) {
    event.preventDefault()
    this.visit(this.queryTarget.value)
  }

  clear(event) {
    event.preventDefault()
    this.queryTarget.value = ""
    this.visit("")
  }

  async visit(term, options = {}) {
    const url = this.urlFor(term)
    this.resultsTarget.setAttribute("aria-busy", "true")
    try {
      const response = await fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "text/html" }
      })
      if (!response.ok) {
        window.location.assign(url)
        return
      }
      const html = await response.text()
      const doc = new DOMParser().parseFromString(html, "text/html")
      const summary = doc.querySelector("[data-returns-search-target='summary']")
      const results = doc.querySelector("[data-returns-search-target='results']")
      if (!summary || !results) {
        window.location.assign(url)
        return
      }
      this.summaryTarget.innerHTML = summary.innerHTML
      this.resultsTarget.innerHTML = results.innerHTML
      this.clearTarget.hidden = (term || "").trim() === ""
      if (options.push !== false) history.pushState({}, "", url.pathname + url.search)
    } catch (_error) {
      window.location.assign(url)
    } finally {
      this.resultsTarget.removeAttribute("aria-busy")
    }
  }

  urlFor(term) {
    const url = new URL(this.urlValue, window.location.origin)
    const value = (term || "").trim()
    if (value) url.searchParams.set("search", value)
    return url
  }
}
